webpackJsonp([1],{

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_boilerplate_index__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_boilerplate_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_boilerplate_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_boilerplate_item__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_boilerplate_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_boilerplate_item__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__components_boilerplate_index___default.a
  }]
}));

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 144:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(173)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(186),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_boilerplate_item__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_boilerplate_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_boilerplate_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_boilerplate_search__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_boilerplate_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_boilerplate_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__boilerplate_data_json__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__boilerplate_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__boilerplate_data_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  components: { boilerplateitem: __WEBPACK_IMPORTED_MODULE_0__components_boilerplate_item___default.a, boilerplatesearch: __WEBPACK_IMPORTED_MODULE_1__components_boilerplate_search___default.a },
  data: function data() {
    return {
      title: 'Boilerplater',
      subtitle: 'The boilerplate search engine',
      githubData: null
    };
  },
  created: function created() {
    this.githubData = __WEBPACK_IMPORTED_MODULE_2__boilerplate_data_json___default.a.items;
  },

  methods: {}
});

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);




var moment = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'boilerplateitem',
    components: {},
    props: ['itemdata', 'type'],
    data: function data() {
        return {
            item: {
                'title': null,
                'url': null,
                'type': null,
                'categories': null,
                'short_description': null,
                'watch_count': null,
                'star_count': null,
                'fork_count': null
            }
        };
    },
    mounted: function mounted() {
        this.item = {
            'title': this.itemdata.name,
            'url': this.itemdata.html_url,
            'description': this.itemdata.description,
            'watch_count': this.itemdata.watchers_count,
            'star_count': this.itemdata.stargazers_count,
            'fork_count': this.itemdata.forks_count,

            'last_updated': this.itemdata.pushed_at,
            'zip_url': 'https://github.com/' + this.itemdata.full_name + '/archive/master.zip'
        };
    },

    methods: {},
    filters: {
        formatDate: function formatDate(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY hh:mm');
            }
        },
        timeSince: function timeSince(date) {
            if (date) {
                return moment(date).fromNow();
            }
        }
    }
});

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_boilerplate_item__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_boilerplate_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_boilerplate_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utilities_loader__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utilities_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_utilities_loader__);






var VueScrollTo = __webpack_require__(190);

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'boilerplatesearch',
    components: { boilerplateitem: __WEBPACK_IMPORTED_MODULE_1__components_boilerplate_item___default.a, loader: __WEBPACK_IMPORTED_MODULE_2__components_utilities_loader___default.a },
    props: ['itemdata'],
    data: function data() {
        return {
            showTagsTxt: "Show more",
            searchTerm: null,
            searchTags: {
                'frameworks': ["Angular2+", "AngularJS", "React", "React Native", "Vue.js", "Ionic", "Cordova", "Knockout.js", ".net", "Laravel", "CodeIgniter", "Symfony"],
                'testing': ["PhantomJS", "Casper", "Mocha", "Jasmine", "Karma", "QUnit", "Selenium"],
                'utilities': ["SCSS", "PostCSS", "Typescript", "Babel", "Gulp", "Grunt", "WebPack", "Docker"],
                'cms': ["Wordpress", "Magento", "Drupal", "Joomla", "WebGUI"]
            },
            searchTagsSelected: [],
            searchResults: [],

            noResults: null,
            isSearching: false

        };
    },

    computed: {
        searchTagsSelectedString: function searchTagsSelectedString() {
            return this.searchTagsSelected.toString().replace(/,/g, "+");
        }
    },
    methods: {
        scrollTo: function scrollTo(element, duration) {
            var options = {
                container: 'body',
                easing: 'ease-in',
                offset: -60,
                cancelable: true,
                onDone: function onDone() {},
                onCancel: function onCancel() {}
            };
            VueScrollTo.scrollTo(element, duration, options);
        },
        search: function search(term) {
            var self = this;

            var tags = self.searchTagsSelectedString;

            self.isSearching = true;
            self.searchResults = null;

            this.scrollTo("#searchResults", 500);

            var url = 'https://api.github.com/search/repositories?q=' + term + '+boilerplate&sort=stars&order=desc';

            if (tags.length && term) url = 'https://api.github.com/search/repositories?q=' + term + '+' + tags + '+boilerplate&sort=stars&order=desc';else if (tags.length) url = 'https://api.github.com/search/repositories?q=' + tags + '+boilerplate&sort=stars&order=desc';

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
                self.searchResults = response.data.items;

                if (self.searchResults.length == 0) self.noResults = true;else self.noResults = false;

                setTimeout(function () {
                    self.isSearching = false;
                }, 1000);
            }).catch(function (error) {
                console.log(error);
            });
        },

        tagSearchTerm: function tagSearchTerm() {
            var temp = this.searchTerm;
            this.searchTerm = this.searchTagsSelected;
        },

        showTags: function showTags() {
            if (document.getElementById('tags').classList.contains('showtags')) {
                document.getElementById('tags').classList.remove('showtags');
                this.showTagsTxt = "Show more";
            } else {
                document.getElementById('tags').classList.add('showtags');
                this.showTagsTxt = "Show less";
            }
        }
    }
});

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'loader',
    props: {
        isloading: {
            default: true
        }
    },
    data: function data() {
        return {};
    }
});

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(147);








var moment = __webpack_require__(0);



window.Hub = new __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */]();

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a }
});

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["a" /* default */], __webpack_require__(146), { moment: moment });

/***/ }),

/***/ 171:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 172:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 173:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 174:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 13,
	"./af.js": 13,
	"./ar": 20,
	"./ar-dz": 14,
	"./ar-dz.js": 14,
	"./ar-kw": 15,
	"./ar-kw.js": 15,
	"./ar-ly": 16,
	"./ar-ly.js": 16,
	"./ar-ma": 17,
	"./ar-ma.js": 17,
	"./ar-sa": 18,
	"./ar-sa.js": 18,
	"./ar-tn": 19,
	"./ar-tn.js": 19,
	"./ar.js": 20,
	"./az": 21,
	"./az.js": 21,
	"./be": 22,
	"./be.js": 22,
	"./bg": 23,
	"./bg.js": 23,
	"./bm": 24,
	"./bm.js": 24,
	"./bn": 25,
	"./bn.js": 25,
	"./bo": 26,
	"./bo.js": 26,
	"./br": 27,
	"./br.js": 27,
	"./bs": 28,
	"./bs.js": 28,
	"./ca": 29,
	"./ca.js": 29,
	"./cs": 30,
	"./cs.js": 30,
	"./cv": 31,
	"./cv.js": 31,
	"./cy": 32,
	"./cy.js": 32,
	"./da": 33,
	"./da.js": 33,
	"./de": 36,
	"./de-at": 34,
	"./de-at.js": 34,
	"./de-ch": 35,
	"./de-ch.js": 35,
	"./de.js": 36,
	"./dv": 37,
	"./dv.js": 37,
	"./el": 38,
	"./el.js": 38,
	"./en-SG": 39,
	"./en-SG.js": 39,
	"./en-au": 40,
	"./en-au.js": 40,
	"./en-ca": 41,
	"./en-ca.js": 41,
	"./en-gb": 42,
	"./en-gb.js": 42,
	"./en-ie": 43,
	"./en-ie.js": 43,
	"./en-il": 44,
	"./en-il.js": 44,
	"./en-nz": 45,
	"./en-nz.js": 45,
	"./eo": 46,
	"./eo.js": 46,
	"./es": 49,
	"./es-do": 47,
	"./es-do.js": 47,
	"./es-us": 48,
	"./es-us.js": 48,
	"./es.js": 49,
	"./et": 50,
	"./et.js": 50,
	"./eu": 51,
	"./eu.js": 51,
	"./fa": 52,
	"./fa.js": 52,
	"./fi": 53,
	"./fi.js": 53,
	"./fo": 54,
	"./fo.js": 54,
	"./fr": 57,
	"./fr-ca": 55,
	"./fr-ca.js": 55,
	"./fr-ch": 56,
	"./fr-ch.js": 56,
	"./fr.js": 57,
	"./fy": 58,
	"./fy.js": 58,
	"./ga": 59,
	"./ga.js": 59,
	"./gd": 60,
	"./gd.js": 60,
	"./gl": 61,
	"./gl.js": 61,
	"./gom-latn": 62,
	"./gom-latn.js": 62,
	"./gu": 63,
	"./gu.js": 63,
	"./he": 64,
	"./he.js": 64,
	"./hi": 65,
	"./hi.js": 65,
	"./hr": 66,
	"./hr.js": 66,
	"./hu": 67,
	"./hu.js": 67,
	"./hy-am": 68,
	"./hy-am.js": 68,
	"./id": 69,
	"./id.js": 69,
	"./is": 70,
	"./is.js": 70,
	"./it": 72,
	"./it-ch": 71,
	"./it-ch.js": 71,
	"./it.js": 72,
	"./ja": 73,
	"./ja.js": 73,
	"./jv": 74,
	"./jv.js": 74,
	"./ka": 75,
	"./ka.js": 75,
	"./kk": 76,
	"./kk.js": 76,
	"./km": 77,
	"./km.js": 77,
	"./kn": 78,
	"./kn.js": 78,
	"./ko": 79,
	"./ko.js": 79,
	"./ku": 80,
	"./ku.js": 80,
	"./ky": 81,
	"./ky.js": 81,
	"./lb": 82,
	"./lb.js": 82,
	"./lo": 83,
	"./lo.js": 83,
	"./lt": 84,
	"./lt.js": 84,
	"./lv": 85,
	"./lv.js": 85,
	"./me": 86,
	"./me.js": 86,
	"./mi": 87,
	"./mi.js": 87,
	"./mk": 88,
	"./mk.js": 88,
	"./ml": 89,
	"./ml.js": 89,
	"./mn": 90,
	"./mn.js": 90,
	"./mr": 91,
	"./mr.js": 91,
	"./ms": 93,
	"./ms-my": 92,
	"./ms-my.js": 92,
	"./ms.js": 93,
	"./mt": 94,
	"./mt.js": 94,
	"./my": 95,
	"./my.js": 95,
	"./nb": 96,
	"./nb.js": 96,
	"./ne": 97,
	"./ne.js": 97,
	"./nl": 99,
	"./nl-be": 98,
	"./nl-be.js": 98,
	"./nl.js": 99,
	"./nn": 100,
	"./nn.js": 100,
	"./pa-in": 101,
	"./pa-in.js": 101,
	"./pl": 102,
	"./pl.js": 102,
	"./pt": 104,
	"./pt-br": 103,
	"./pt-br.js": 103,
	"./pt.js": 104,
	"./ro": 105,
	"./ro.js": 105,
	"./ru": 106,
	"./ru.js": 106,
	"./sd": 107,
	"./sd.js": 107,
	"./se": 108,
	"./se.js": 108,
	"./si": 109,
	"./si.js": 109,
	"./sk": 110,
	"./sk.js": 110,
	"./sl": 111,
	"./sl.js": 111,
	"./sq": 112,
	"./sq.js": 112,
	"./sr": 114,
	"./sr-cyrl": 113,
	"./sr-cyrl.js": 113,
	"./sr.js": 114,
	"./ss": 115,
	"./ss.js": 115,
	"./sv": 116,
	"./sv.js": 116,
	"./sw": 117,
	"./sw.js": 117,
	"./ta": 118,
	"./ta.js": 118,
	"./te": 119,
	"./te.js": 119,
	"./tet": 120,
	"./tet.js": 120,
	"./tg": 121,
	"./tg.js": 121,
	"./th": 122,
	"./th.js": 122,
	"./tl-ph": 123,
	"./tl-ph.js": 123,
	"./tlh": 124,
	"./tlh.js": 124,
	"./tr": 125,
	"./tr.js": 125,
	"./tzl": 126,
	"./tzl.js": 126,
	"./tzm": 128,
	"./tzm-latn": 127,
	"./tzm-latn.js": 127,
	"./tzm.js": 128,
	"./ug-cn": 129,
	"./ug-cn.js": 129,
	"./uk": 130,
	"./uk.js": 130,
	"./ur": 131,
	"./ur.js": 131,
	"./uz": 133,
	"./uz-latn": 132,
	"./uz-latn.js": 132,
	"./uz.js": 133,
	"./vi": 134,
	"./vi.js": 134,
	"./x-pseudo": 135,
	"./x-pseudo.js": 135,
	"./yo": 136,
	"./yo.js": 136,
	"./zh-cn": 137,
	"./zh-cn.js": 137,
	"./zh-hk": 138,
	"./zh-hk.js": 138,
	"./zh-tw": 139,
	"./zh-tw.js": 139
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 177;

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(174)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(187),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(171)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(184),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(175)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(188),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ada51752",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 184:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-2 mb-5"
  }, [_c('div', {
    staticClass: "search-block"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search for..."
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.search(_vm.searchTerm)
      }
    }
  }, [_vm._v("Search Boilerplates")])])]), _vm._v(" "), _c('div', {
    staticClass: "row tags mt-3",
    attrs: {
      "id": "tags"
    }
  }, [_c('ul', {
    staticClass: "col-sm-6 d-flex"
  }, [_c('span', {
    staticClass: "h5 mb-1"
  }, [_vm._v("Frameworks")]), _vm._v(" "), _vm._l((_vm.searchTags.frameworks), function(tag, index) {
    return _c('li', {
      staticClass: "input-group"
    }, [_c('label', {
      staticClass: "custom-control custom-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.searchTagsSelected),
        expression: "searchTagsSelected"
      }],
      staticClass: "custom-control-input",
      attrs: {
        "type": "checkbox",
        "name": "searchTagsSelected"
      },
      domProps: {
        "value": tag,
        "checked": Array.isArray(_vm.searchTagsSelected) ? _vm._i(_vm.searchTagsSelected, tag) > -1 : (_vm.searchTagsSelected)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.searchTagsSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.searchTagsSelected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.searchTagsSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.searchTagsSelected = $$c
          }
        }, function($event) {
          return _vm.tagSearchTerm()
        }]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-indicator"
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-description"
    }, [_vm._v(_vm._s(tag))])])])
  }), _vm._v(" "), _c('span', {
    staticClass: "h5 mb-1 mt-3"
  }, [_vm._v("CMS")]), _vm._v(" "), _vm._l((_vm.searchTags.cms), function(tag, index) {
    return _c('li', {
      staticClass: "input-group"
    }, [_c('label', {
      staticClass: "custom-control custom-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.searchTagsSelected),
        expression: "searchTagsSelected"
      }],
      staticClass: "custom-control-input",
      attrs: {
        "type": "checkbox",
        "name": "searchTagsSelected"
      },
      domProps: {
        "value": tag,
        "checked": Array.isArray(_vm.searchTagsSelected) ? _vm._i(_vm.searchTagsSelected, tag) > -1 : (_vm.searchTagsSelected)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.searchTagsSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.searchTagsSelected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.searchTagsSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.searchTagsSelected = $$c
          }
        }, function($event) {
          return _vm.tagSearchTerm()
        }]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-indicator"
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-description"
    }, [_vm._v(_vm._s(tag))])])])
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "col-sm-6 d-flex"
  }, [_c('span', {
    staticClass: "h5 mb-1"
  }, [_vm._v("Testing")]), _vm._v(" "), _vm._l((_vm.searchTags.testing), function(tag, index) {
    return _c('li', {
      staticClass: "input-group"
    }, [_c('label', {
      staticClass: "custom-control custom-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.searchTagsSelected),
        expression: "searchTagsSelected"
      }],
      staticClass: "custom-control-input",
      attrs: {
        "type": "checkbox",
        "name": "searchTagsSelected"
      },
      domProps: {
        "value": tag,
        "checked": Array.isArray(_vm.searchTagsSelected) ? _vm._i(_vm.searchTagsSelected, tag) > -1 : (_vm.searchTagsSelected)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.searchTagsSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.searchTagsSelected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.searchTagsSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.searchTagsSelected = $$c
          }
        }, function($event) {
          return _vm.tagSearchTerm()
        }]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-indicator"
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-description"
    }, [_vm._v(_vm._s(tag))])])])
  }), _vm._v(" "), _c('span', {
    staticClass: "h5 mb-1 mt-3"
  }, [_vm._v("Utilities")]), _vm._v(" "), _vm._l((_vm.searchTags.utilities), function(tag, index) {
    return _c('li', {
      staticClass: "input-group"
    }, [_c('label', {
      staticClass: "custom-control custom-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.searchTagsSelected),
        expression: "searchTagsSelected"
      }],
      staticClass: "custom-control-input",
      attrs: {
        "type": "checkbox",
        "name": "searchTagsSelected"
      },
      domProps: {
        "value": tag,
        "checked": Array.isArray(_vm.searchTagsSelected) ? _vm._i(_vm.searchTagsSelected, tag) > -1 : (_vm.searchTagsSelected)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.searchTagsSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tag,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.searchTagsSelected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.searchTagsSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.searchTagsSelected = $$c
          }
        }, function($event) {
          return _vm.tagSearchTerm()
        }]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-indicator"
    }), _vm._v(" "), _c('span', {
      staticClass: "custom-control-description"
    }, [_vm._v(_vm._s(tag))])])])
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showTags()
      }
    }
  }, [_vm._v(_vm._s(_vm.showTagsTxt))])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5 row justify-content-center",
    attrs: {
      "id": "searchResults"
    }
  }, [_c('loader', {
    attrs: {
      "isloading": _vm.isSearching
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSearching),
      expression: "!isSearching"
    }]
  }, [_vm._l((_vm.searchResults), function(boilerplate, index) {
    return [_c('boilerplateitem', {
      staticClass: "col-12",
      attrs: {
        "itemdata": boilerplate,
        "type": 'search'
      }
    })]
  })], 2), _vm._v(" "), (_vm.noResults && !_vm.isSearching) ? _c('h3', [_vm._v("No boilerplates have been found for your search. Try something simpler.")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 185:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boilerplate-item mb-3"
  }, [_c('h2', [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _c('h4', {
    staticClass: "h5 mb-2"
  }, [_c('i', {
    staticClass: "fa fa-star mr-2",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.item.star_count) + "\n      "), _c('i', {
    staticClass: "fa fa-eye mr-2 ml-4",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.item.watch_count) + "\n      "), _c('i', {
    staticClass: "fa fa-code-fork mr-2 ml-4",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.item.fork_count) + "\n  ")]), _vm._v(" "), _c('p', [_c('small', [_c('strong', [_vm._v("Last updated")]), _vm._v(" " + _vm._s(_vm._f("timeSince")(_vm.itemdata.updated_at)))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.item.description))]), _vm._v(" "), _c('p', {
    staticClass: "boilerplate-links mb-0 mt-2"
  }, [_c('a', {
    staticClass: "btn btn-primary align-items-center mr-2",
    attrs: {
      "href": _vm.item.url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github mr-2",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n          View Repository\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.item.zip_url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-archive-o mr-2",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n          Download\n      ")])])])
},staticRenderFns: []}

/***/ }),

/***/ 186:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 187:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-12"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), _c('p', [_vm._v("Start your boilerplate search using either the text input or boilerplate categories")]), _vm._v(" "), _c('boilerplatesearch')], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 188:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isloading) ? _c('div', {
    staticClass: "sk-folding-cube"
  }, [_c('div', {
    staticClass: "sk-cube1 sk-cube"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube2 sk-cube"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube4 sk-cube"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube3 sk-cube"
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

module.exports = {"items":[{"title":"react boilerplate","url":"https://github.com/react-boilerplate/react-boilerplate","type":"React Boilerplate","categories":["React","JavaScript","Redux","WebPack"],"description":"Start your next react project in seconds. A highly scalable, offline-first foundation with the best DX and a focus on performance and best practices","get_started":{"1":"Clone the repo using git clone --depth=1 https://github.com/react-boilerplate/react-boilerplate.git","2":"Move to the appropriate directory: cd react-boilerplate.","3":"Run npm run setup in order to install dependencies and clean the git repo. At this point you can run npm start to see the example app at http://localhost:3000."},"watch_count":"441","star_count":"14898","fork_count":"2376"},{"title":"React Starter Kit","url":"https://github.com/kriasoft/react-starter-kit","type":"Javascript Boilerplate","categories":["React","WebPack","Browsersync","GraphQL","Express"],"description":"React Starter Kit is an opinionated boilerplate for web development built on top of Node.js, Express, GraphQL and React, containing modern web development tools such as Webpack, Babel and Browsersync. Helping you to stay productive following the best practices. A solid starting point for both professionals and newcomers to the industry.","get_started":{"1":"git clone -o react-starter-kit -b master --single-branch //  https://github.com/kriasoft/react-starter-kit.git MyApp","2":"cd MyApp","3":"yarn install","4":"yarn start"},"watch_count":"536","star_count":"15012","fork_count":"3067"},{"title":"Angular Boilerplate","url":"https://github.com/smorcuend/angular4-boilerplate","type":"Javascript Boilerplate","categories":["Angular","Angular2","Angular4","WebPack","Typescript","Covalent"],"description":"Inspired and based on Angular2-webpack-starter project. Teradata Covalent UI Platform built on Angular-Material intergated.","get_started":{"1":"npm install or yarn install","2":"npm start or yarn start"},"watch_count":"1","star_count":"2","fork_count":"0"},{"title":"Angular4 Webpack Starter","url":"https://github.com/AngularClass/angular-starter","type":"Javascript Boilerplate","categories":["Angular","Angular4","WebPack","Typescript","Karma","Protractor","Jasmine"],"description":"This seed repo serves as an Angular starter for anyone looking to get up and running with Angular and TypeScript fast. Using a Webpack 3 for building our files and assisting with boilerplate. We're also using Protractor for our end-to-end story and Karma for our unit tests.","get_started":{"1":"npm install or yarn install","2":"npm start or yarn start"},"watch_count":"587","star_count":"8639","fork_count":"4962"},{"title":"AngularJS-Boilerplate","url":"https://github.com/jbutko/AngularJS-Boilerplate","type":"Javascript Boilerplate","categories":["Angular","AngularJS","SCSS","Gulp"],"description":"Simple AngularJS Boilerplate to kick start your new project with SASS support and Gulp watch/build tasks","get_started":{"1":"bower install angularjs-boilerplate or git clone https://github.com/jbutko/AngularJS-Boilerplate.git","2":"npm install","3":"npm start or gulp"},"watch_count":"24","star_count":"379","fork_count":"135"}]}

/***/ }),

/***/ 194:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(172)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(185),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[170]);


// WEBPACK FOOTER //
// static/js/app.4693db927d2992cb35e1.js